<template>
    <!-- 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校) -->
    <!-- 军校招生 -->
    <div class="military_school studyway_common_father">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner_tool.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">什么是定向生？</h6>
            <div class="main_box">
                <p>定向生是指为了帮助边远地区、少数民族地区和工作环境比较艰苦的行业培养人才，保证他们得到一定数量的毕业生而制定的一项政策。所谓定向就是定学校、定专业、定就业。<br/>考生自愿填报有关高等学校定向就业招生志愿并按有关政策一旦被录取为定向生，须在入学注册前与高校及定向就业单位签订有关定向就业协议。<br/>填报定向志愿时应注意3个问题：定向生的生源范围；明确用人单位的就业去向；必须要与用人单位签订定向就业协议。</p>
            </div>    
        </div>
        <div class="benefit main">
            <h6 class="main_title">备考须知</h6>
            <div class="main_box">
                <p>(1)符合当年统一高考报名条件。</p>
                <p>(2)定向的地区为内蒙古、广西、贵州、云南、西藏 、甘肃、青海、宁夏、新疆等9个省(自治区)，国家重点建设项目中工作环境比较艰苦的单位也可定向。教育部所属院校还可面向农业、林业、地质、能源、建材、气象、国防军工、解放军等部门定向招生。</p>
                <p>(3)选报定向志愿的考生，应填写《定向生志愿表》。高等学校应根据考生填写的定向志愿录取 定向生，并在录取通知中注明定向地区或部门。</p>
                <p>(4)录取定向生，一般与非定向生执行同一录取分数标准，在院校录取控制分数线以上，如果不能完成定向招生来源计划，可在该院校录取分数线以下20分以内择优录取。</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {}
    },
    methods: {},
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    @import "../study_way_common.less";
    .military_school {
        .liucheng {
            ul {
                display: flex;
                flex-wrap: wrap;
                li {
                    text-align: center;
                    line-height: 50px;
                    /* width: 189px; */
                    height: 50px;
                    /* padding-right: 60px; */
                    background: url(/imgs/wayToStudy/common/icon_liucheng.png) no-repeat right center;
                    margin-right: 20px;
                    padding-right: 53px;
                    background-size: 20px 20px;
                    // &:last-child {
                    //     padding-right: 0px;
                    // }
                }
            }
        }
        .universities  ul {
            overflow: hidden;
            width: 933px;
            li {
                font-size: 14px;
                box-sizing: border-box;
                float: left;
                width: 25%;
                border: 1px solid #eaeaea;
                margin-left: -1px;
                margin-top: -1px;
                min-height: 42px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 20px;
                text-align: center;
                &:nth-child(4n+1) {
                    margin-left: 0px;
                }
                &:nth-child(-n + 4) {
                    margin-top: 0px;
                }
            }
    }
        
    }
    
</style>